import {params} from "@/systemInfo.js";
import {showNotification} from "@/services/notification.js";
import axios from 'axios';

export function getFormattedDate(text = '') {
    const date = new Date();

    if (text === 't') {
        const options = {month: 'short', day: 'numeric'}; // "Mmm DD"
        return new Intl.DateTimeFormat('en-US', options).format(date);
    } else {
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }
}


export function getFormattedTime() {
    const date = new Date();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const amPm = hours >= 12 ? 'PM' : 'AM';
    const formattedTime = `${hours % 12 || 12}:${minutes} ${amPm}`;

    return `${formattedTime}`;
}

export function getFormattedDateTime(date = '') {
    if (date) {
        return `${getFormattedDate(date)}, ${getFormattedTime()}`
    } else {
        return `${getFormattedDate()}, ${getFormattedTime()}`;
    }
}

export function formatDateTime(date) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const amPm = hours >= 12 ? 'PM' : 'AM';
    const formattedTime = `${hours % 12 || 12}:${minutes} ${amPm}`;

    return `${month}/${day}/${year}, ${formattedTime}`;
}

export function pauseBg() {
    const v = document.querySelector(".background-video");
    if (v) {
        v.pause();
        console.log("Dynamic background paused. Reboot to restart")
    } else {
        console.log("Unable to pause dynamic background")
    }
}

// export function setSystemTime() {
//     systemInfo.time = getFormattedTime();
//     setInterval(() => {
//         systemInfo.time = getFormattedTime();
//     }, 60000);
// }

const WIFI_ON_ICON =
    '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<g stroke="#FFFFFF" stroke-width="1.5">' +
    '<path d="M5 12.55a11 11 0 0 1 14.08 0"/>' +
    '<path d="M1.42 9a16 16 0 0 1 21.16 0"/>' +
    '<path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>' +
    '<circle cx="12" cy="20" r="1"/>' +
    '</g>' +
    '</svg>'

export const WIFI_OFF_ICON =
    '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<g stroke="#FFFFFF" stroke-width="2">' +
    '<path d="M5 12.55a11 11 0 0 1 14.08 0"/>' +
    '<path d="M1.42 9a16 16 0 0 1 21.16 0"/>' +
    '<path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>' +
    '<circle cx="12" cy="20" r="1"/>' +
    '</g>' +
    '<g stroke="#ff3006" stroke-width="2">' +
    '<line x1="3" y1="3" x2="21" y2="21"/>' +
    '<line x1="21" y1="3" x2="3" y2="21"/>' +
    '</g>' +
    '</svg>'

let reconnectTimer = null

// Call this from your 'online' event listener
export function handleOnline(debounceMs = 1000) {
    if (reconnectTimer) clearTimeout(reconnectTimer)

    reconnectTimer = setTimeout(() => {
        console.log("back online");
        showNotification(`Connected!<br>You are back online`, `${WIFI_ON_ICON}`);
    }, debounceMs)
}

// Call this from your 'offline' event listener
export function handleOffline() {
    if (reconnectTimer) clearTimeout(reconnectTimer)
    console.log("connection lost");
    showNotification(`Connection problem<br>No network available`, `${WIFI_OFF_ICON}`, true, false, false)
}

// Optional: clean-up helper if you ever need to tear things down
export function cleanup() {
    if (reconnectTimer) {
        clearTimeout(reconnectTimer)
        reconnectTimer = null
    }
}


/**
 * Get list of games available for the current site.
 * @returns {Promise<Object>} Object containing array of games, and available status
 * @param api_url App API url
 * @param site_id Site ID
 */
export async function fetchGamesForSite(api_url, site_id) {
    try {
        const response = await axios.get(`${api_url}/api/getgamesforsite/`, {
            params: {siteid: site_id},
            timeout: params.gameIdValidationTimeout || 10000
        })

        const games = response.data
        return {games: games, success: true}
    } catch (e) {
        console.log(`[API] No games returned for app: ${e}`)
        return {games: [], unavailable: true}
    }
}

/**
 * Validate a manually-entered game ID.
 * @param {string} api_url url og api endpoint
 * @param {string} id game ID to validate
 * @returns {Promise<Object>} Object containing valid boolean and availability status
 */
export async function validateGameId(api_url, id) {
    try {
        const response = await axios.get(`${api_url}/api/validateid/`, {
            params: {id: id.toUpperCase()},
            timeout: params.gameIdValidationTimeout || 10000
        })

        console.warn('RESPONSE: ', response)

        const valid = response.data === true
        return {valid: valid, success: true, unavailable: false}
    } catch (e) {
        return {valid: false, unavailable: true, message: `Request failed: ${e}`}
    }
}
